/*
* Builds a label string consisting of code, name, or "<code> - <name>"
* @param {Object} model
* @return String
*/
export default function (model) {
  if (!model || (!model.code && !model.name && !model.meta_name)) {
    return ''
  }
  if (model.meta_name) {
    return `${model.meta_name}`
  }
  if (model.code && (!model.name)) {
    return `${model.code}`
  } else if (!model.code && model.name) {
    return `${model.name}`
  }
  return `${model.code} - ${model.name}`
}



// WEBPACK FOOTER //
// ./src/utils/helpers/BuildLabelString.js